/**
 * Use this to read and update Code
 * @module CodeSelector
 * @category State
 */

import { CodeMirrorCodeState } from "./codeAtom";
import { StackCfKeyAtom } from "./stackAtoms";
import { selector } from "recoil";

const PageCount = selector<number>({
  key: "PageCount",
  get: ({ get }) => {
    const stackCfKey = get(StackCfKeyAtom);
    if (!stackCfKey) return 0;
    const code = get(CodeMirrorCodeState(stackCfKey));
    const lineCount = (code.match(/^===\s*$/gm) || []).length;
    return lineCount + 1;
  },
});

export { PageCount };
